// extracted by mini-css-extract-plugin
module.exports = {"prefix":"styles_prefix__l2tyR","postfix":"styles_postfix__YwO0h"};